class ContactService {
    constructor($rootScope, $q, $location, $log, $timeout, wtcpjsClientProviderService, anchorInfoService, endpointModel) {
        this.$rootScope = $rootScope;
        this.$q = $q;
        this.$log = $log;
        this.filterId = wtcpjsClientProviderService.filterTypes.addressBookFilter;
        this.getClient = wtcpjsClientProviderService.getClient;
        this.aiSvc = anchorInfoService;
        this.endpointModel = endpointModel;

        // TBD: When anchorInfo support is added to Proxy we should revisit the design of this service
        // We should cache results and bounds check the cache before fetching a new endpoints from
        // the address book filter. For now, we get everything so we will just leave it as a fire and forget

        $rootScope.$on('endpointModel.presenceUpdated', (e, channelEndpoints, channelId, endpointId, userName, filterIds) => {
            // This checks if presenceUpdated occurred because of channel activity (which only happens for the Self flagged user)
            // or if presenceUpdated occurred because of the endpoint channel filter has been updated
            let isMeOrChannelUser = (!filterIds || filterIds.indexOf(this.filterId) > -1);
            if (isMeOrChannelUser) {

                if (!channelEndpoints.has(endpointId)) { // Endpoint deleted
                    $rootScope.$broadcast('contactService.contactOffline', endpointId, userName);
                } else {
                    let endpoint = channelEndpoints.get(endpointId);
                    if (endpoint.callAlias || endpoint.privateTxtEnabled) {
                        let spcFlags = endpoint.flags.get(0);
                        if(spcFlags) {
                            if (spcFlags.Self) {
                                $rootScope.$broadcast('contactService.selfUpdated', endpoint);
                            } else {
                                $rootScope.$broadcast('contactService.contactUpdated', endpoint);
                            }
                        }
                    }
                }
            }
        });
    }

    getContacts(anchor) {
        var $q = this.$q;
        var $log = this.$log;
        var defer = this.$q.defer();
        var getClient = this.getClient;
        var endpointModel = this.endpointModel;
        var filterId = this.filterId;
        var index = 0;
        var matchIndx = 0;
        var data = [];
        var _myEndpoint = null;

        var getEndpointInfo = function(userName) {
            for (var x = matchIndx; x < data.length; x++) {
                if (data[x].userName === userName.toLowerCase()) {
                    return data[matchIndx = x];
                }
            }
            return null;
        };

       // get anchor page only
        getClient()
            .setEndpointAddressBookFilter(filterId, { "displayName": "*" }, "disposition;CallAlias;displayName;participantType", 0,anchor)
            .then((resp) => {
                data = [];
                index = 0;
                _myEndpoint = endpointModel.getMyEndpoint();
                resp.endpointPropertyInfo.forEach((ep) => {
                    if (ep.endpointInfo.endpointId === "0") {
                        data[index++] = {
                            userName: ep.endpointInfo.endpointName.toLowerCase(),
                            name: ep.endpointProperties.displayName,
                            type: ep.endpointProperties.participantType,
                            isPresent: false,
                            canP2P: ep.endpointProperties.participantType === 'RADIO' ? true : false,
                            canTxt: false,
                            endpoints: new Set(),
                            callAlias: ep.endpointProperties.callAlias
                        };
                    } else if (!ep.endpointInfo.endpointFlags.Self &&
                        ep.endpointInfo.endpointName !== _myEndpoint.userName) {
                        var info = getEndpointInfo(ep.endpointInfo.endpointName);
                        info.isPresent = true;
                        // this isn' working, for some reason we get contacts before the phone line is active which makes no sense...
                        info.canP2P = _myEndpoint.callAlias && ep.endpointProperties.disposition !== 'Phone'
                            ? true
                            : false;
                        info.canTxt = ep.endpointProperties.privateTxtEnabled;
                        info.endpoints.add(ep.endpointInfo.endpointId);
                        let model = endpointModel.addEndpoint(0,
                            ep.endpointInfo.endpointId,
                            ep.endpointInfo.endpointName,
                            ep.endpointInfo.endpointFlags);
                        model.filterIds.push(filterId);
                    }
                });
                defer.resolve({ totalContacts: resp.endpoints, data });
            }).catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    }
} 

angular
    .module('webcomm')
    .service('contactService', [
        '$rootScope',
        '$q',
        '$location',
        '$log',
        '$timeout',
        'wtcpjsClientProviderService',
        'anchorInfoService',
        'endpointModel',
        ContactService]);